export default __webpack_public_path__ + "static/media/Whoarewe.85844b44.png";